import { AxiosResponse } from 'axios';

import client from '../../lib/service/publication.service';
import { Consume, Publication } from './publications.types';

type PublicationsResponse = { publications: Publication[] };
type PublicationResponse = { publication: Publication };
type PublicationConsumeResponse = { publication: Consume };

const PUBLICATIONS = `/v1/publications`;
const PUBLICATIONS_FEATURED = `/v1/publications/featured`;
const PUBLICATION = (publicationId: string) =>
  `/v1/publications/${publicationId}`;
const COMPANIES_PUBLICATIONS = (companyId: string) =>
  `/v1/companies/${companyId}/publications`;

const PUBLICATIONS_AVAILABLE = `/v1/publications/available`;
const PUBLICATION_AVAILABLE = (publicationId: string) =>
  `/v1/publications/available/${publicationId}`;

const PUBLICATIONS_CONSUME = (publicationId: string) =>
  `/v1/publications/${publicationId}/consume`;

const PUBLICATIONS_REVIEW = (publicationId: string) =>
  `/v1/publications/${publicationId}/review`;

export async function getPublications(): Promise<Publication[]> {
  const response = await client.get<null, AxiosResponse<PublicationsResponse>>(
    PUBLICATIONS,
  );
  return response.data.publications;
}

export async function getPublicationsAvailable(): Promise<Publication[]> {
  const response = await client.get<null, AxiosResponse<PublicationsResponse>>(
    PUBLICATIONS_AVAILABLE,
  );
  return response.data.publications;
}

export async function getPublicationsConsume(
  publicationId: string,
): Promise<Consume> {
  const response = await client.get<
    null,
    AxiosResponse<PublicationConsumeResponse>
  >(PUBLICATIONS_CONSUME(publicationId));
  return response.data.publication;
}

export async function getPublicationsFeatured(): Promise<Publication[]> {
  const response = await client.get<null, AxiosResponse<PublicationsResponse>>(
    PUBLICATIONS_FEATURED,
  );
  return response.data.publications;
}

export async function getCompaniesPublications(
  companyId,
): Promise<Publication[]> {
  const response = await client.get<null, AxiosResponse<PublicationsResponse>>(
    COMPANIES_PUBLICATIONS(companyId),
  );
  return response.data.publications;
}

export async function getPublication(
  publicationId: string,
): Promise<Publication> {
  const response = await client.get<null, AxiosResponse<PublicationResponse>>(
    PUBLICATION(publicationId),
  );
  return response.data.publication;
}

export async function getPublicationAvailable(
  publicationId: string,
): Promise<Publication> {
  const response = await client.get<null, AxiosResponse<PublicationResponse>>(
    PUBLICATION_AVAILABLE(publicationId),
  );
  return response.data.publication;
}

export async function postPublication(params): Promise<Publication> {
  const response = await client.post<
    PublicationResponse,
    AxiosResponse<PublicationResponse>
  >(PUBLICATIONS, params);
  return response.data.publication;
}

export async function putPublication(params): Promise<Publication> {
  const response = await client.put<
    PublicationResponse,
    AxiosResponse<PublicationResponse>
  >(PUBLICATION(params.publication.id), params);
  return response.data.publication;
}

export async function putPublicationReview(params): Promise<Publication> {
  const response = await client.put<
    PublicationResponse,
    AxiosResponse<PublicationResponse>
  >(PUBLICATIONS_REVIEW(params.publication.id), params);
  return response.data.publication;
}
